// import { cardsData } from '@/mocks/listings/card-listings'
import { Box, Typography } from '@mui/material'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { ICardProps } from '../../ui/card/types'
import { useSearchListing } from '@/services/listing/listing.service'
import { getCardsListings } from '@services/listing/selectors'
import Card from '../../ui/card'
import { useDashboardContext } from '@/providers/dashboard/hooks/useDashboardContext'
import { PaginationComponent } from '@/components/pagination'
import { axios } from '@/lib/axios'
import { FlexGrid } from '@/components'

const baseUrl = process.env.API_BASE_URL

export const ListingGridCards: React.FC<any> = ({
  filterTitle,
  injectFilter,
  currentTab,
}) => {
  const { params: selectedFilters, setParams } = useDashboardContext()
  const [page, setPage] = React.useState(1)
  const [filters, setFilters] = useState<Record<string, string[]>>({})
  const [totalPages, setTotalPages] = React.useState<number | undefined>(
    undefined,
  )

  const obtainFilters = async () => {
    const res = await axios.get(`${baseUrl}/categories`)
    if (res.ok) {
      delete res.data.licence
      setFilters({ ...res.data })
    }
  }

  const sizeItems = 30

  const dataObject = useSearchListing({
    select: getCardsListings,
    ...{
      ...selectedFilters,
      ...currentTab,
      size: sizeItems,
      from: (page - 1) * sizeItems,
    },
  })

  React.useEffect(() => {
    setParams({ title: selectedFilters?.title })
    obtainFilters()
  }, [])

  React.useEffect(() => {
    setPage(1)
  }, [selectedFilters])

  React.useEffect(() => {
    const dataCount = dataObject.data?.count
    if (dataCount) {
      setTotalPages(Math.ceil(dataCount / sizeItems))
    }
  }, [dataObject.data?.count])

  const cardsData = dataObject.data?.cards as ICardProps[]
  const { isLoading, isError } = dataObject

  const cardElements = cardsData
    ? cardsData.map((card) => (
        <Card
          key={card.id}
          title={card.title}
          companyName={card.companyName}
          description={card.description}
          verified={card.verified}
          isInstantPurchase={card.isInstantPurchase}
          id={card.id}
        />
      ))
    : []

  return (
    <>
      <FlexGrid
        isLoading={isLoading}
        isError={isError}
        currentPage={page}
        pageSize={sizeItems}
        totalCount={dataObject.data?.count || 0}
      >
        {cardElements}
      </FlexGrid>

      {cardElements.length > 0 && (
        <PaginationComponent
          totalPages={totalPages}
          page={page}
          setPage={setPage}
        />
      )}
    </>
  )
}
